export default "__VITE_ASSET__a378d5da__$_?nuxt_component=async&nuxt_component_name=SvgoLogoW__"